/* Dead On Display — Concept A store pages (product, collection, collections list).
   Gallery, option pickers, quantity, add to cart, cart drawer, quick add, Shop Pay.
   Cart uses Shopify's AJAX cart API (/cart/add.js, /cart.js, /cart/change.js) and shows Shopify's
   own totals and discounts, the same way the hanger page does. Nothing here calculates a price. */
(function () {
  "use strict";
  const D = window.DODS || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = c => "$" + ((c || 0) / 100).toFixed(2);
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const reduce = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const QTY_MAX = 999, DMIN = D.discountMin || 3, DPCT = D.discountPct || 10;   // set in snippets/dod-discount-min.liquid and dod-discount-pct.liquid
  const HANG = {}; (D.hangers || []).forEach(h => { HANG[h.id] = h; });
  const I = {
    checkS: '<svg class="ico ico-sm" viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    minus: '<svg class="ico ico-sm" viewBox="0 0 24 24"><path d="M5 12h14"/></svg>',
    plusS: '<svg class="ico ico-sm" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>'
  };

  /* ---------------- toast ---------------- */
  function toast(m) { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("show"); clearTimeout(toast.t); toast.t = setTimeout(() => t.classList.remove("show"), 2600); }

  /* ---------------- layers (drawer) ---------------- */
  let layer = null, opener = null;
  const FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function openLayer(el, from) {
    if (!el) return;
    layer = el; opener = from || document.activeElement;
    el.classList.add("show"); el.setAttribute("aria-hidden", "false");
    const sc = $("#dodp-scrim"); if (sc) sc.classList.add("show");
    document.documentElement.classList.add("dodp-locked");
    document.dispatchEvent(new Event("dods:layer"));
    setTimeout(() => { const f = $(FOCUSABLE, el) || el; f.focus({ preventScroll: true }); }, 60);
  }
  function closeLayer() {
    if (!layer) return;
    const el = layer; layer = null;
    el.classList.remove("show"); el.setAttribute("aria-hidden", "true");
    const sc = $("#dodp-scrim"); if (sc) sc.classList.remove("show");
    document.documentElement.classList.remove("dodp-locked");
    document.dispatchEvent(new Event("dods:layer"));
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }
  document.addEventListener("keydown", e => {
    if (!layer) return;
    if (e.key === "Escape") { e.preventDefault(); closeLayer(); return; }
    if (e.key === "Tab") {
      const f = $$(FOCUSABLE, layer).filter(x => x.offsetParent !== null); if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });
  document.addEventListener("click", e => { if (layer && (e.target.closest("[data-close]") || e.target === $("#dodp-scrim"))) closeLayer(); });

  /* ---------------- cart ---------------- */
  let cart = null, busy = false;
  function api(url, body) {
    const opt = body ? { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, credentials: "same-origin", body: JSON.stringify(body) }
                     : { headers: { "Accept": "application/json" }, credentials: "same-origin" };
    return fetch(url, opt).then(r => r.json().catch(() => ({})).then(j => { if (!r.ok) throw new Error(j.description || j.message || "Something went wrong. Please try again."); return j; }))
      .catch(e => { if (e instanceof TypeError) throw new Error("Couldn't reach the cart. Check your connection and try again."); throw e; });
  }
  function syncHeader(c) {
    const ind = $(".site-header__cart-indicator"); if (ind) ind.classList.toggle("hide", !c.item_count);
    $$("[data-cart-count]").forEach(n => { n.textContent = c.item_count; });
  }
  function refreshCart() { return api("/cart.js").then(c => { cart = c; renderCart(); syncHeader(c); return c; }); }
  // Buy it now and anything else that needs checkout: the cart page's own route (POST /cart with checkout)
  function goCheckout() { const f = document.createElement("form"); f.method = "post"; f.action = "/cart"; f.hidden = true; const i = document.createElement("input"); i.type = "hidden"; i.name = "checkout"; i.value = "1"; f.appendChild(i); document.body.appendChild(f); f.submit(); }
  function setBusy(el, on) { if (!el || !el.classList) return; el.classList.toggle("is-busy", on); el.setAttribute("aria-busy", String(on)); }
  function cartAdd(items, from) {
    if (busy) return Promise.resolve(); busy = true; setBusy(from, true);
    return api("/cart/add.js", { items }).then(() => refreshCart()).then(() => openLayer($("#dodp-drawer"), from))
      .catch(e => toast(e.message)).then(() => { busy = false; setBusy(from, false); });
  }
  function cartChange(key, v) {
    const it = cart && cart.items.find(x => x.key === key); if (!it || busy) return;
    const d = Number(v), q = v === "rm" ? 0 : d < 0 ? Math.max(0, it.quantity + d) : Math.min(QTY_MAX, it.quantity + d);
    busy = true;
    api("/cart/change.js", { id: key, quantity: q }).then(c => { cart = c; renderCart(); syncHeader(c); })
      .catch(e => toast(e.message)).then(() => { busy = false; });
  }
  const lineImg = it => it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
  function renderCart() {
    const b = $("#dr-b"), f = $("#dr-f"); if (!b || !f) return;
    const c = cart || { items: [], item_count: 0, total_price: 0 };
    const items = c.items || [];
    const hq = items.filter(i => HANG[i.variant_id]).reduce((a, i) => a + i.quantity, 0);
    const saved = items.reduce((a, i) => a + (i.original_line_price - i.final_line_price), 0)
      + (c.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
    $("#dr-n").textContent = c.item_count ? "(" + c.item_count + ")" : "";
    const hDisc = items.some(i => HANG[i.variant_id] && i.final_line_price < i.original_line_price);
    const prog = hq ? '<div class="dr-prog' + (hDisc ? " ok" : "") + '">' + (hDisc ? I.checkS + '<span><b>' + DPCT + '% off</b> is applied to your hangers.</span>'
      : (hq < DMIN ? '<span>Add ' + (DMIN - hq) + ' more hanger' + (DMIN - hq > 1 ? "s" : "") + ', any size, for <b>' + DPCT + '% off</b> your hangers.</span>' : "")) + '</div>' : "";
    const lines = items.map(it => {
      const h = HANG[it.variant_id], free = it.final_line_price === 0;
      const sub = h ? h.label + " · " + h.cap + " lb" : (it.variant_title && it.variant_title !== "Default Title" ? esc(it.variant_title) : "");
      const price = free ? "Free" : (it.final_line_price < it.original_line_price ? "<s>" + money(it.original_line_price) + "</s>" + money(it.final_line_price) : money(it.final_line_price));
      const title = h ? "European Skull Mount Hanger" : it.product_title;
      return '<div class="line">' + (it.image ? '<div class="ph mini"><img src="' + esc(lineImg(it)) + '" alt="" loading="lazy"></div>' : '<div class="ph mini kit-ic" aria-hidden="true">' + I.checkS + '</div>')
        + '<div class="line-m"><div class="line-t">' + (it.url ? '<a href="' + esc(it.url) + '">' + esc(title) + '</a>' : esc(title)) + '</div><div class="line-s">' + sub + '</div>'
        + '<div class="line-q"><div class="lq"><button data-line="-1" data-k="' + esc(it.key) + '" aria-label="One less ' + esc(title) + '">' + I.minus + '</button><span class="num" aria-live="polite">' + it.quantity + '</span><button data-line="1" data-k="' + esc(it.key) + '" aria-label="One more ' + esc(title) + '"' + (it.quantity >= QTY_MAX ? " disabled" : "") + '>' + I.plusS + '</button></div><button class="line-rm" data-line="rm" data-k="' + esc(it.key) + '" aria-label="Remove ' + esc(title) + '">Remove</button></div>'
        + '</div><div class="line-p num">' + price + '</div></div>';
    }).join("");
    const qa = hq ? '<div class="qa"><span class="qa-h">' + (hq < DMIN ? "Another trophy? Add another hanger." : "Add another hanger") + '</span><div class="qa-row">'
      + (D.hangers || []).filter(h => h.available !== false).map(h => '<button data-qa="' + h.id + '"><b>+ ' + h.label + '</b><span>' + esc(h.sp) + '</span><span class="num">' + money(h.price) + '</span></button>').join("")
      + '</div></div>' : "";
    b.innerHTML = items.length ? prog + lines + qa : '<div class="empty-cart"><p>Your cart is empty.</p><button class="btn btn-primary" data-close>Keep shopping</button></div>';
    f.hidden = !items.length;
    f.innerHTML = '<div class="dr-tot"><span>Subtotal' + (saved > 0 ? ' <em class="num">You save ' + money(saved) + '</em>' : "") + '</span><span class="num">' + money(c.total_price) + '</span></div>'
      + '<p class="dr-note">Taxes and shipping calculated at checkout · Orders typically process in 1–2 business days</p>'
      /* checkout the same way the theme's cart page does it: POST /cart with name="checkout" (works without JavaScript, and checkout apps hook it as usual) */
      + '<form class="dr-co" action="/cart" method="post" novalidate><button class="btn btn-primary" type="submit" name="checkout" data-checkout>Checkout<span class="sep"></span><span class="num">' + money(c.total_price) + '</span></button></form>'
      + '<p class="dr-xp">Secure checkout · <a href="/cart">View cart</a></p>';
  }
  document.addEventListener("click", e => {
    const l = e.target.closest("[data-line]"); if (l) { cartChange(l.dataset.k, l.dataset.line); return; }
    const q = e.target.closest("[data-qa]"); if (q) { cartAdd([{ id: Number(q.dataset.qa), quantity: 1 }], q); return; }
    const k = e.target.closest("[data-quick]"); if (k) { e.preventDefault(); cartAdd([{ id: Number(k.dataset.quick), quantity: 1 }], k); }
  });

  /* ---------------- gallery ---------------- */
  function initGallery(gal) {
    const tr = $(".gal-track", gal); if (!tr) return;
    let cur = 0;
    const slides = () => tr.children;
    function mark(i) {
      cur = i;
      $$(".gal-th", gal).forEach((t, k) => t.setAttribute("aria-current", String(k === i)));
      $$(".gal-dots i", gal).forEach((d, k) => d.classList.toggle("on", k === i));
      $$("video", tr).forEach((v, k) => { if (!v.closest(".gal-slide") || Array.prototype.indexOf.call(slides(), v.closest(".gal-slide")) !== i) v.pause(); });
    }
    function go(i) {
      const n = slides().length; if (!n) return;
      i = (i + n) % n;
      tr.scrollTo({ left: i * tr.clientWidth, behavior: reduce() ? "auto" : "smooth" });
      mark(i);
    }
    gal.addEventListener("click", e => {
      const t = e.target.closest("[data-go]"); if (t) { go(Number(t.dataset.go)); return; }
      const s = e.target.closest("[data-step]"); if (s) go(cur + Number(s.dataset.step));
    });
    tr.addEventListener("scroll", () => { clearTimeout(tr._t); tr._t = setTimeout(() => mark(Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth))), 80); }, { passive: true });
    tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") { e.preventDefault(); go(cur + 1); } if (e.key === "ArrowLeft") { e.preventDefault(); go(cur - 1); } });
    gal._go = go;
  }
  $$("[data-gal]").forEach(initGallery);

  /* ---------------- product form ---------------- */
  const P = D.product, form = $("[data-form]");
  if (P && form) {
    const sel = $("[data-variant-select]", form), atc = $("[data-atc]", form), sp = $("[data-shoppay]", form);
    const qIn = $("[data-qty-in]", form), groups = $$("fieldset.opt", form), addons = $$("[data-addon]", form);
    const addonTotal = () => addons.filter(a => a.checked).reduce((t, a) => t + Number(a.dataset.addonPrice), 0);
    const sticky = $("#dods-sticky"), stBtn = sticky && $("[data-st-atc]", sticky), stSub = sticky && $("[data-st-sub]", sticky);
    let v = P.variants.find(x => x.id === P.current) || P.variants[0];
    let qty = 1;
    form.classList.add("is-js"); sel.tabIndex = -1;   // the option buttons replace the select for everyone with JavaScript
    const chosen = () => groups.map(g => { const b = $('.opt-b[aria-pressed="true"]', g); return b ? b.dataset.v : null; });
    function match(opts) { return P.variants.find(x => x.options.every((o, i) => opts[i] == null || o === opts[i])); }
    function paint(userPick) {
      $("[data-price]").textContent = money(v.price);
      const cmp = $("[data-compare]"); if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = money(v.compare); }
      sel.value = String(v.id);
      atc.disabled = !v.available;
      const total = (v.price + addonTotal()) * qty;
      atc.innerHTML = v.available ? 'Add to cart<span class="sep"></span><span class="num">' + money(total) + '</span>' : "Sold out";
      $$("[data-each]", form).forEach(x => { x.hidden = qty < 2; });
      if (stBtn) { stBtn.disabled = !v.available; stBtn.innerHTML = v.available ? 'Add to cart<span class="sep"></span><span class="num">' + money(total) + '</span>' : "Sold out"; }
      if (stSub) stSub.textContent = (groups.length && !groups.some(g => g.hasAttribute("data-money")) ? v.options.join(" / ") + " · " : "") + money(v.price);
      const stock = $("[data-stock]"); if (stock) { const n = v.inv; stock.hidden = !(n > 0 && n < 10); stock.textContent = (n > 0 && n < 10) ? n + " available" : ""; }
      if (sp) sp.hidden = !v.available;
      groups.forEach((g, gi) => {
        const lab = $("[data-optval]", g); if (lab) lab.textContent = g.hasAttribute("data-cap") ? v.options[gi].toLowerCase() : g.hasAttribute("data-money") ? v.options[gi].replace(/\.00$/, "") : v.options[gi];
        // a value is unavailable only if no in-stock variant has it together with the options chosen before it
        const pool = P.variants.filter(x => x.options.slice(0, gi).every((o, i) => o === v.options[i]));
        $$(".opt-b", g).forEach(b => {
          const any = pool.filter(x => x.options[gi] === b.dataset.v);
          const ok = any.some(x => x.available);
          b.setAttribute("aria-pressed", String(b.dataset.v === v.options[gi]));
          b.classList.toggle("is-out", !ok);
          b.setAttribute("aria-label", b.textContent.trim() + (!any.length ? ", unavailable" : !ok ? ", sold out" : ""));
        });
      });
      const q = $$("[data-qty]", form); q[0].disabled = qty <= 1; q[1].disabled = qty >= QTY_MAX;
      if (qIn && document.activeElement !== qIn) qIn.value = qty;
      try { const u = new URL(location.href); if (userPick && P.variants.length > 1) { u.searchParams.set("variant", v.id); history.replaceState(null, "", u); } } catch (_) {}
    }
    groups.forEach((g, gi) => g.addEventListener("click", e => {
      const b = e.target.closest(".opt-b"); if (!b) return;
      const opts = v.options.slice(); opts[gi] = b.dataset.v;
      const exact = match(opts);
      // never change a choice the shopper already made: if that exact combination exists it is shown (as "Sold out"
      // when it is out of stock); only a combination the product doesn't offer at all falls back to the nearest one
      const keepEarlier = x => x.options[gi] === b.dataset.v && x.options.slice(0, gi).every((o, i) => o === opts[i]);
      v = exact || P.variants.find(x => keepEarlier(x) && x.available) || P.variants.find(x => keepEarlier(x)) || P.variants.find(x => x.options[gi] === b.dataset.v) || v;
      paint(true);
      if (v.media) { const gal = $("[data-gal]"), th = gal && $('.gal-th[data-mid="' + v.media + '"]', gal); if (th && gal._go) gal._go(Number(th.dataset.go)); }
    }));
    sel.addEventListener("change", () => { v = P.variants.find(x => String(x.id) === sel.value) || v; paint(true); });
    form.addEventListener("click", e => { const b = e.target.closest("[data-qty]"); if (!b) return; qty = Math.max(1, Math.min(QTY_MAX, qty + Number(b.dataset.qty))); paint(); });
    if (qIn) {
      qIn.addEventListener("input", () => { if (qIn.value === "") return; qty = Math.max(1, Math.min(QTY_MAX, parseInt(qIn.value, 10) || 1)); paint(); });
      qIn.addEventListener("change", () => { qty = Math.max(1, Math.min(QTY_MAX, parseInt(qIn.value, 10) || 1)); qIn.value = qty; paint(); });
    }
    form.addEventListener("submit", e => {
      e.preventDefault();
      if (!v.available) { toast("That option is sold out right now."); return; }
      cartAdd(itemsNow(), atc);
    });
    // add-ons go in the same request, at the same quantity (as on the hanger page)
    function itemsNow() { return [{ id: v.id, quantity: qty }].concat(addons.filter(a => a.checked).map(a => ({ id: Number(a.dataset.addon), quantity: qty }))); }
    addons.forEach(a => a.addEventListener("change", () => paint()));
    if (stBtn) stBtn.addEventListener("click", () => { if (v.available) cartAdd(itemsNow(), stBtn); });
    // sticky bar: shows once the main Add to cart button has scrolled off the top, hides near the footer
    if (sticky) {
      let raf = 0;
      const measure = () => { raf = 0; const r = atc.getBoundingClientRect(), f = $(".site-footer"); const nearEnd = f && f.getBoundingClientRect().top < innerHeight;
        const show = r.bottom < 0 && !nearEnd && !layer; sticky.classList.toggle("show", show); sticky.setAttribute("aria-hidden", String(!show)); document.body.classList.toggle("dodp-has-sticky", show); };
      addEventListener("scroll", () => { if (!raf) raf = requestAnimationFrame(measure); }, { passive: true });
      addEventListener("resize", () => { if (!raf) raf = requestAnimationFrame(measure); });
      document.addEventListener("dods:layer", measure);
    }
    // Buy it now, as on the live page: add to the cart (keeping what's already in it), then go to checkout
    if (sp) sp.addEventListener("click", () => {
      if (!v.available || busy) return; busy = true; setBusy(sp, true);
      api("/cart/add.js", { items: itemsNow() }).then(() => { goCheckout(); }).catch(e => { busy = false; setBusy(sp, false); toast(e.message); });
    });
    paint();
  }

  /* ---------------- start ---------------- */
  renderCart(); refreshCart().catch(() => {});
})();
